<template>
  <div class="task-actions">
    <div class="task-actions-assignee">
      <div class="task-actions-title">
        Assignee
      </div>
      <div class="task-actions-body">
        <app-select class="task-actions-selector assignee-type"
                    :searchable = true
                    v-model="taskAssignee"
                    customType="assignee"
                    @change="changeTaskAssignee()"
                    :options="taskAssigneeForSelect"
                    :imageBase="imageBase"
                    :customActive="false"
                    :clearable="false"
                    placeholder="Type in a name..."
                    data-vv-name="Assignee"
                    data-lpignore="true"
                    name="assignee"
                    id="assignee" />
      </div>
    </div>
    <div class="task-actions-status" v-if="taskStatus">
      <div class="task-actions-title">
        Status
      </div>
      <div class="task-actions-body">
        <app-select class="task-actions-selector status-type"
                    :class="'status-type-' + taskStatus.value"
                    :searchable="false"
                    v-model="taskStatus"
                    customType="status"
                    @change="changeTaskStatus()"
                    :options="taskStatusesForSelectBasedOnTaskAssessment"
                    :customActive="false"
                    :clearable="false"
                    data-vv-name="Status"
                    data-lpignore="true"
                    name="status"
                    id="status" />
      </div>
    </div>
    <div class="task-actions-move-to" v-if="taskBoard">
      <div class="task-actions-title">
        Board
      </div>
      <div class="task-actions-body">
        <app-select class="task-actions-selector board-type"
                    :class="'board-type-' + taskBoard.value"
                    :searchable="false"
                    v-model="taskBoard"
                    @change="changeTaskBoard()"
                    :options="taskBoardsForSelect"
                    :customActive="false"
                    :clearable="false"
                    data-vv-name="Board"
                    data-lpignore="true"
                    name="board"
                    id="board" />
      </div>
    </div>
    <div>

      <button v-on:click.prevent="resetTaskMessages()" class="reset-task-messages background-1-20 color-2-100" v-if="isAdmin">
        Reset task history
      </button>
    </div>
  </div>
</template>

<script>
  import api from '@/api'
  import {mapActions, mapGetters} from 'vuex'
  import AppSelect from '@/components/admin/common/Select'

  export default {
    name: 'task-actions',
    model: {
      prop: 'taskChanged',
      event: 'task-changed'
    },
    props: {
      company: Number,
      taskChanged: Boolean,
      taskId: {
        type: Number,
        required: true
      },
      assignee: {
        type: null,
        required: true
      },
      status: {
        type: Number,
        required: true
      },
      assessed: {
        type: Boolean,
        default: false,
        required: true
      },
      board: {
        type: Number,
        default: 2
      }
    },
    data () {
      return {
        taskStatus: null,
        taskAssignee: null,
        taskBoard: null,
        disableAPI: false,
        infMsgTitle: '',
        infMsgDescription: '',
        infMsgClass: '',
        confOpened: null
      }
    },
    computed: {
      ...mapGetters([
        'isAdmin',
        'taskStatuses',
        'taskStatusesForSelect',
        'taskAssigneeForSelect',
        'getConfData'
      ]),
      taskStatusesForSelectBasedOnTaskAssessment () {
        const statuses = []
        for (let i = 0; i < this.taskStatusesForSelect.length; i++) {
          const item = this.taskStatusesForSelect[i]
          if (this.isAdmin) {
            if (item.value === 3) {
              continue
            }
          } else {
            if (this.assessed && item.value === 3) {
              continue
            }
            if (!this.assessed && item.value === 4) {
              continue
            }
          }
          statuses.push(item)
        }
        return statuses
      },
      imageBase () {
        return api.serverUserImages
      },
      taskBoardsForSelect () {
        return [
          {
            label: 'Focus',
            value: 1
          },
          {
            label: 'Backlog',
            value: 2
          }
        ]
      }
    },
    methods: {
      ...mapActions([
        'clearConfAction',
        'setInformationMsg',
        'initConfAction'
      ]),
      changeTaskStatus () {
        if (!this.taskStatus || this.taskStatus.value === this.status) {
          return
        }
        const data = {
          taskId: this.taskId,
          status: this.taskStatus.value
        }
        if (this.company) {
          data['company'] = this.company
        }
        this.$http.post(`${api.URLS.task}/change/status`, data, api.headersAuthSettings).then(() => {
          this.$emit('task-changed', {
            status: this.taskStatus.value
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      changeTaskAssignee () {
        if (!this.taskAssignee || this.taskAssignee.value === this.assignee) {
          return
        }
        const data = {
          taskId: this.taskId,
          assignee: this.taskAssignee.value
        }
        if (this.company) {
          data['company'] = this.company
        }
        this.$http.post(`${api.URLS.task}/change/assignee`, data, api.headersAuthSettings).then((response) => {
          this.$emit('task-changed', {
            assignee: {
              name: response.body.name,
              fullName: response.body.fullName,
              image: response.body.image
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      changeTaskBoard () {
        const board = this.taskBoardsForSelect.find((item) => item.value === this.board)
        if (!board) {
          return
        }
        if (this.taskBoard.value === this.board) {
          return
        }
        const data = {
          taskId: this.taskId,
          board: this.taskBoard.value
        }
        if (this.company) {
          data['company'] = this.company
        }
        this.$http.post(`${api.URLS.task}/change/board`, data, api.headersAuthSettings).then((res) => {
          this.$emit('task-changed', {
            board: res.body.boardName
          })
        }).catch((err) => {
          console.log(err)
        })
      },
      setTaskStatus () {
        const status = this.taskStatuses.find((item) => item.id === this.status)
        if (status) {
          this.taskStatus = {
            label: status.name,
            value: status.id
          }
        }
      },
      setTaskAssignee () {
        const assignee = this.taskAssigneeForSelect.find((item) => item.value === this.assignee)
        if (assignee) {
          this.taskAssignee = assignee
        }
      },
      setTaskBoard () {
        const board = this.taskBoardsForSelect.find((item) => item.value === this.board)
        if (board) {
          this.taskBoard = board
        } else if (this.board === 3) {
          this.taskBoard = {
            label: 'Completed',
            value: 3
          }
        }
      },
      resetTaskMessages () {
        this.confOpened = 'reset-task-messages'
        this.initConfAction({
          actionName: 'resetTaskMessagesById'
        })
      },
      resetTaskMessagesConfirmed () {
        this.$http.put(`${api.URLS.task}/reset-messages/${this.company}/${this.taskId}`, {}, api.headersAuthSettings)
          .then((res) => {
            this.infMsgTitle = 'Task history was successfully reset. Reloading...'
            this.infMsgDescription = ''
            this.infMsgClass = 'success'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            setTimeout(() => {
              this.$router.go()
            }, 2000)
          })
          .catch((err) => {
            console.log(err)
            this.disableAPI = false
            this.infMsgTitle = 'Error. We can\'t reset task history because '
            for (let error in err.body.error.exception) {
              this.infMsgTitle += err.body.error.exception[error].message + ' '
            }
            if (this.isAdmin) {
              this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
            } else {
              this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
            }
            this.infMsgClass = 'error'
            this.setInformationMsg({
              isShown: true,
              title: this.infMsgTitle,
              text: this.infMsgDescription,
              className: this.infMsgClass
            })
            console.log(err)
          })
        this.getConfData.actionConfirmed = false
      }
    },
    components: {
      AppSelect
    },
    watch: {
      status (value) {
        if (value) {
          this.setTaskStatus()
        }
      },
      board (value) {
        if (value) {
          this.setTaskBoard()
        }
      },
      assignee (value) {
        if (value) {
          this.setTaskAssignee()
        }
      },
      taskStatuses (value) {
        if (value) {
          this.setTaskStatus()
        }
      },
      taskAssigneeForSelect (value) {
        if (value) {
          this.setTaskAssignee()
        }
      },
      'getConfData.actionConfirmed' (value) {
        if (value) {
          if (this.confOpened === 'reset-task-messages') this.resetTaskMessagesConfirmed()
          this.clearConfAction()
        }
      }
    },
    created () {
      this.setTaskStatus()
      this.setTaskAssignee()
      this.setTaskBoard()
    }
  }
</script>

<style src="@/assets/scss/components/tasks/task-actions.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// TaskActions.vue?59c83542